/* eslint-disable no-self-compare */
import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import AddToCalendar from '../../components/AddToCalendar';
import { closeRequest, unAcceptRequest } from '../../../services/activities';

const AssignedRequestListItem = ({
    _id,
    Status,
    RequestedTime,
    Name,
    RequestType_Icon,
    RequestSlots,
    refreshLists,
    ResidentName,
    ResidentImage,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    let slotsTime = new Date().toISOString();

    if (RequestSlots && RequestSlots.On && Date.parse(RequestSlots.On) === Date.parse(RequestSlots.On)) {
        const slotDateWithTime = `${RequestSlots.On} ${RequestSlots.At}`;
        slotsTime =
            Date.parse(slotDateWithTime) === Date.parse(slotDateWithTime)
                ? new Date(slotDateWithTime).toISOString()
                : new Date(`${RequestSlots.On} 10:00:00 AM`).toISOString();
    }

    const sendToast = (type = 'warn', message) => {
        if (type === 'success') {
            toast.success(message, {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (type === 'warn') {
            toast.warn(message, {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    };

    const closeReq = (requestId) => {
        setIsLoading(true);
        closeRequest(requestId)
            .then(() => {
                setIsLoading(false);
                sendToast('success', 'Closed the request');
                return refreshLists(Date.now());
            })
            .catch((err) => {
                sendToast('warn', err.message);
                return refreshLists(Date.now());
            });
    };

    const reOpenReq = (requestId) => {
        setIsLoading(true);
        unAcceptRequest(requestId)
            .then(() => {
                setIsLoading(false);
                sendToast('success', 'Re-opened the request');
                return refreshLists(Date.now());
            })
            .catch((err) => {
                sendToast('warn', err.message);
                return refreshLists(Date.now());
            });
    };

    return (
        <>
            <div className="resident-image-section">
                {ResidentImage ? <img className="resident-image" src={ResidentImage} alt="" /> : <img className="resident-image" src='/avatar_placeholder.png' alt="" />}
            </div>
            <div className="flex-1">
                <div>
                    <div className="title">{ResidentName}</div>
                    <div className="timestamp">{new Date(RequestedTime).toLocaleString()}</div>
                </div>
                <div className="title">{Name}</div>
            </div>

            <div className="icon-section">
                {RequestType_Icon && <img className="mr-8" src={RequestType_Icon} alt="" />}
                <AddToCalendar
                    calendarEvent={{
                        title: `Speak2 - ${Name} ${RequestSlots && RequestSlots.To ? 'to ' + RequestSlots.To : ''}`,
                        description: Object.entries(RequestSlots)
                            .map(([name, value]) => `${name}: ${value}`)
                            .join('\n'),
                        location: '',
                        startTime: slotsTime,
                        endTime: slotsTime,
                    }}
                />
                <Button
                    icon
                    type="button"
                    loading={isLoading}
                    onClick={(e) => {
                        e.stopPropagation();
                        closeReq(_id);
                    }}
                >
                    <Icon name="check circle"></Icon>
                </Button>
                <Button
                    icon
                    type="button"
                    loading={isLoading}
                    onClick={(e) => {
                        e.stopPropagation();
                        reOpenReq(_id);
                    }}
                >
                    <Icon name="times circle"></Icon>
                </Button>
            </div>
        </>
    );
};

export default AssignedRequestListItem;
